import styled from "styled-components";
import Variables from "../../assets/styleVariables";

export const Container = styled.div`
  border-radius: 4px;
  border: solid 1px ${Variables.colors.complementary_400};
  padding: 17px 52px 10px 32px;
  &:hover {
    box-shadow: 0 1px 4px 0 #ccc;
  }
  margin: 8px 0;
  width: 100%;
  cursor: pointer;
  background-color: ${Variables.colors.white};
  &:last-of-type {
    margin-bottom: 84px;
  }
`;
export const CardView = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  .header-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    .date {
      color: ${Variables.colors.complementary_700};
      font-size: ${Variables.font_sizes.x_medium};
    }
    .left-part {
      display: flex;
      align-items: center;
      .state {
        color: ${Variables.colors.complementary_500};
        font-size: ${Variables.font_sizes.x2_medium};
      }
      .counts {
        margin-right: 8px;
        background-color: ${Variables.colors.red_400};
        width: 28px;
        height: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: ${Variables.colors.white};
        font-size: ${Variables.font_sizes.x_small};
        border-radius: 50%;
      }
    }
  }
  .text {
    margin-top: 8px;
    font-size: ${Variables.font_sizes.large};
    color: ${Variables.colors.complementary_800};
    line-height: 1.56;
    max-width: 95%;
    word-break: break-all;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }
`;
